import {post} from "../../commons/Commons";
import {CORP_REPORT_BY_TEAM_GROUP_URL} from "../../commons/Routing";

export const REPORT_BY_TEAM_GROUP_REQUEST = "REPORT_BY_TEAM_GROUP_REQUEST";
export const REPORT_BY_TEAM_GROUP_SUCCESS = "REPORT_BY_TEAM_GROUP_SUCCESS";
export const REPORT_BY_TEAM_GROUP_ERROR = "REPORT_BY_TEAM_GROUP_ERROR";

export const REPORT_BY_TEAM_GROUP_IS_BUILT = "REPORT_BY_TEAM_GROUP_IS_BUILT";

export const REPORT_BY_TEAM_GROUP_TOGGLE_PERSON = "REPORT_BY_TEAM_GROUP_TOGGLE_PERSON";

export const REPORT_BY_TEAM_GROUP_PUSH_PERSONS = "REPORT_BY_TEAM_GROUP_PUSH_PERSONS";


export function togglePerson(person_id) {
  return {
    type: REPORT_BY_TEAM_GROUP_TOGGLE_PERSON,
    payload: person_id
  }
}

export function reportIsBuilt() {
  return {
    type: REPORT_BY_TEAM_GROUP_IS_BUILT,
    payload: true,
  }
}

export function reportIsBuiltClear() {
  return {
    type: REPORT_BY_TEAM_GROUP_IS_BUILT,
    payload: false,
  }
}

export function getReport(persons) {

  return (dispatch, getStore) => {
    dispatch({
      type: REPORT_BY_TEAM_GROUP_REQUEST,
      payload: null,
    });

    persons = persons || getStore().report_by_team_group.selected || [];

    post(CORP_REPORT_BY_TEAM_GROUP_URL, {persons: persons})
      .done((d) => {

        if (d.status === 'ok') {
          dispatch({
            type: REPORT_BY_TEAM_GROUP_SUCCESS,
            payload: d.data,
          });
        }
        else {
          dispatch({
            type: REPORT_BY_TEAM_GROUP_ERROR,
            payload: null,
          });
        }
      })
      .fail((jqXHR) => {
        let error = jqXHR.responseText;
        if (jqXHR.responseJSON && jqXHR.responseJSON.detail) {
          error = jqXHR.responseJSON.detail;
        }

        dispatch({
          type: REPORT_BY_TEAM_GROUP_ERROR,
          payload: error,
        });
      })
  }

}

export function pushPersonIds(pids) {
  return {
    type: REPORT_BY_TEAM_GROUP_PUSH_PERSONS,
    payload: pids
  }
}